import React, { useEffect } from "react";
import Button from "../../../../ui/button/Button";
import history from "../../../../../utils/history";
import Panel from "../../../../ui/panel/Panel";
import Text from "../../../../ui/text/Text";
import "./DeclinedPaymentEmailTemplate.scss";
import { AppState } from "../../../../..";
import { useDispatch, useSelector } from "react-redux";
import { IAuthReducerState } from "../../../../../reducers/authReducer";
import { ICompanyBrandingReducerState } from "../../../../../reducers/companyBrandingReducer";
import { Row, Col } from "react-grid-system";
import EmailPreivewContainer from "../../brand-customization/email-preview/EmailPreivewContainer";
import BackNavigationPanel from "../../../../ui/back-navigation-panel/BackNavigationPanel";
import { useParams } from "react-router";
import { IEmailCustomizationReducerState } from "../../../../../reducers/emailCustomizationReducer";
import { getEmailTemplateValues, resetEmailTemplateValues } from "../../../../../actions/emailCustomizationActions";
import EmailEditableArea from "../email-editable-area/EmailEditableArea";
import { DunningFailedEmailType, DunningFailedEmailTypeMap } from "../../../../../models/Emails";

const DeclinedPaymentEmailTemplate: React.FC = () => {
  const dispatch = useDispatch();
  const { emailType } = useParams() as { emailType: keyof typeof DunningFailedEmailType };
  const companyBrandingReducer = useSelector<AppState, ICompanyBrandingReducerState>(state => state.companyBrandingReducer);
  const emailCustomizationReducer = useSelector<AppState, IEmailCustomizationReducerState>(state => state.emailCustomizationReducer);
  const authReducer = useSelector<AppState, IAuthReducerState>(state => state.auth);

  const { customArea1, customArea2, customArea3 } = emailCustomizationReducer;
  const { currentCompanyId, companyName } = authReducer;
  const { highlightColor } = companyBrandingReducer;
  const defaultHighLightColor = "#F87847";

  useEffect(() => {
    const emailTypeProto = DunningFailedEmailTypeMap[emailType]
    dispatch(getEmailTemplateValues(currentCompanyId as number, companyName, emailTypeProto));
    return () => {dispatch(resetEmailTemplateValues())};
  }, []);


  return (
    <div>
      <BackNavigationPanel
        title={`DECLINED_PAYMENTS_EMAIL_TEMPLATE_BACK_PANEL_TITLE_${emailType.toUpperCase()}`} shouldTranslateTitle={true}
        onClick={() => history.push("/configuration/dunning-process")} />

      <Row>
        <Col sm={8}>
          <Panel className="declined-payment-email-template__panel" noMargin>
            <EmailPreivewContainer>

              <Text
                content="DECLINED_PAYMENTS_EMAIL_TEMPLATE_GREETINGS"
                className="email-preview__details__text"
                component="span"
                noMargin
              />

              <Text
                content={<span dangerouslySetInnerHTML={{ __html: customArea1 }}></span>}
                shouldTranslate={false}
                className="email-preview__details__text bar bar-blue"
                component="span"
                noMargin
              />

              <Text
                content="DECLINED_PAYMENTS_EMAIL_TEMPLATE_REATTEMPT_THE_PAYMENT"
                className="email-preview__details__text"
                component="span"
                noMargin
              />

              <div className="email-preview__details__button">
                <Button
                  id="select-plan-continue"
                  type="button"
                  className="email-preview__details__button-orange declined-payment-email-template__button"
                  title="DECLINED_PAYMENTS_EMAIL_TEMPLATE_REATTEMPT_BUTTON"
                  style={{ backgroundColor: !!highlightColor ? highlightColor : defaultHighLightColor }}
                />
              </div>

              <Text
                style={{ color: !!highlightColor ? highlightColor : defaultHighLightColor }}
                content="DECLINED_PAYMENTS_EMAIL_TEMPLATE_VIEW_INVOICE"
                className="email-preview__details__text email-preview__details__text-center email-preview__details__text-underlined"
                component="span"
                noMargin
              />

              <Text
                content={<span dangerouslySetInnerHTML={{ __html: customArea2 }}></span>}
                shouldTranslate={false}
                className="email-preview__details__text bar bar-orange"
                component="span"
                noMargin
              />

              <Text
                content={<span dangerouslySetInnerHTML={{ __html: customArea3 }}></span>}
                shouldTranslate={false}
                className="email-preview__details__text email-preview__details__text-bold"
                component="span"
                noMargin
              />

              <Text
                content="DECLINED_PAYMENTS_EMAIL_TEMPLATE_REAGRDS"
                className="email-preview__details__text"
                component="span"
                noMargin
              />

              <Text
                content={companyName}
                className="email-preview__details__text"
                component="span"
                shouldTranslate={false}
                noMargin
              />
            </EmailPreivewContainer>
          </Panel>
        </Col>
        <Col sm={4}>
         <EmailEditableArea
          id="DeclinedPaymentEmailTemplate"
          emailCustomCopyOneValue={customArea1}
          emailCustomCopyTwoValue={customArea2}
          emailCustomCopyThreeValue={customArea3}
          emailCustomCopyThreeIsVisible={false}
          emailAdsIsVisible={false}
          showCompanyAlertToggle={true}
          showProductAlertToggle={true}
          showPlanAlertToggle={true}
          />
        </Col>
      </Row>
    </div>
  )
}

export default DeclinedPaymentEmailTemplate;